import React, { createContext, useContext, useState, useEffect } from 'react';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

const SettingsContext = createContext(null);

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState({
    bakeryName: 'Apni Dhani Bakery',
    phone: '+91 9001204207',
    whatsappNumber: '+919001204207',
    email: 'info@apnidhanibakery.com',
    address: 'Apni Dhani Bakery, Jaipur, Rajasthan - 302001',
    logo: '',
  });

  useEffect(() => {
    fetch(`${API}/settings`)
      .then(r => r.json())
      .then(data => { if (data && !data.message) setSettings(data); })
      .catch(() => {});
  }, []);

  const refetchSettings = () => {
    fetch(`${API}/settings`)
      .then(r => r.json())
      .then(data => { if (data && !data.message) setSettings(data); })
      .catch(() => {});
  };

  return (
    <SettingsContext.Provider value={{ settings, setSettings, refetchSettings }}>
      {children}
    </SettingsContext.Provider>
  );
};

export const useSettings = () => useContext(SettingsContext);
